const SESSION_ID_KEY = 'aiq_session_id'

function isDemoMode(): boolean {
  try {
    return new URLSearchParams(window.location.search).get('demo') === 'true'
  } catch {
    return false
  }
}

export function getSessionId(): string {
  if (isDemoMode()) return 'demo-session'

  try {
    let sessionId = sessionStorage.getItem(SESSION_ID_KEY)
    if (!sessionId) {
      sessionId = crypto.randomUUID()
      sessionStorage.setItem(SESSION_ID_KEY, sessionId)
    }
    return sessionId
  } catch {
    return `fallback-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
  }
}
